if (window.innerWidth <= 1199) {
  $(document).ready(function () {
    var $slider1 = $('.one-fourth.first');
    var $slider2 = $('.one-fourth.second');

    if ($slider1.length && $slider2.length) {
      var flickity1 = new Flickity($slider1[0], {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        draggable: true,
        freeScroll: false,
        autoPlay: false,
        pageDots: false,
        prevNextButtons: false,
        selectedAttraction: 0.01,
        friction: 0.15
      });

      var flickity2 = new Flickity($slider2[0], {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        draggable: true,
        freeScroll: false,
        autoPlay: false,
        pageDots: true,
        prevNextButtons: false,
        selectedAttraction: 0.01,
        friction: 0.15
      });

      flickity1.on('change', function (index) {
        flickity2.select(index);
      });

      flickity2.on('change', function (index) {
        flickity1.select(index);
      });
    }
  });
}
